import { THEMES, defaultTheme } from '../../configs/LayoutConfig';
import { getQueryParams } from './Common';

const LIGHT_MODE = 'light-mode';
const KEY_THEME = 'theme';

export const changeUITheme = theme => {
  if (theme === THEMES.LIGHT) {
    document.body.classList.add(LIGHT_MODE);
  } else {
    document.body.classList.remove(LIGHT_MODE);
  }
};

export const getTheme = () => {
  return (
    getQueryParams('theme') || localStorage.getItem(KEY_THEME) || defaultTheme
  );
};

export const saveTheme = theme => {
  localStorage.setItem(KEY_THEME, theme);
};
